export const WindowsIcon = ({ size = 28 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <path d="M2 5.3L13.4 3.7V14.5H2V5.3Z" fill="#00ADEF" />
        <path d="M14.6 3.5L30 1V14.5H14.6V3.5Z" fill="#00ADEF" />
        <path d="M2 15.7H13.4V26.5L2 24.9V15.7Z" fill="#00ADEF" />
        <path d="M14.6 15.7H30V31L14.6 28.6V15.7Z" fill="#00ADEF" />
    </svg>
);

export const MacIcon = ({ size = 28 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <path d="M22.5 3C20.7 3.2 18.6 4.4 17.4 5.9C16.4 7.2 15.6 9.2 15.9 11.1C17.8 11.1 19.7 10 20.9 8.5C22 7.1 22.7 5.1 22.5 3Z" fill="#444" />
        <path d="M27.5 11.5C26.1 9.8 24.1 8.9 22.2 8.9C19.9 8.9 18.8 10 17 10C15.1 10 13.8 8.9 11.8 8.9C9.1 8.9 6.3 10.6 4.6 13.5C2.2 17.7 2.6 25.5 6.8 29.5C8.3 31 10.1 32 11.8 32C13.6 32 14.4 31 16.9 31C19.4 31 20.2 32 22.1 32C23.9 32 25.7 30.9 27.2 29.4C28.3 28.3 29.1 27 29.7 25.6C25.8 24 24.1 19.7 27.5 16.4C26.4 14.5 27.5 13 27.5 11.5Z" fill="#444" />
    </svg>
);

export const LaptopIcon = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M1 21h22" />
    </svg>
);

export const WifiIcon = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <path d="M5 12.5C7.3 10.2 10 9 12 9s4.7 1.2 7 3.5" />
        <path d="M8.5 15.5C9.8 14.2 10.9 13.5 12 13.5s2.2.7 3.5 2" />
        <circle cx="12" cy="18.5" r="1" fill="currentColor" />
        <path d="M1.5 9.5C4.5 6.5 8 5 12 5s7.5 1.5 10.5 4.5" />
    </svg>
);

export const CameraIcon = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
    </svg>
);

export const ShieldIcon = () => (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

export const InfoCircleIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }}>
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
);

export const WarningTriangleIcon = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1 }}>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);

export const DownloadArrowIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
        <path d="M12 2v13M7 10l5 5 5-5" />
        <path d="M3 20h18" />
    </svg>
);

export const ChatIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);
